'use strict';
import OrderPagination from './components/OrderPagination.vue';

export default class {
    constructor() {
        Vue.component('order-pagination', OrderPagination);
    }
}
